import { applyMiddleware, combineReducers, compose, Middleware } from "redux"
import { configureStore } from "@reduxjs/toolkit"
import thunk from "redux-thunk"
import { themeReducer } from "./themeReducer"
import { doctorProfileReducer } from "./doctorProfileReducer"
import { accountDataReducer } from "./accountDataReducer"
import { doctorTenantReducer } from "./doctorTenantReducer"
import { patientDataReducer } from "./patientDataReducer"
import { doctorSelectionReducer } from "./doctorSelectionReducer"
import { staticDataReducer } from "./staticDataReducer"
import { IAppState } from "../interfaces/IAppState"
import { ongoingDoctorConsultationReducer } from "./ongoingDoctorConsultationReducer"
import { sectionSuggestionReducer } from "./sectionSuggestionReducer"
import { pdfTemplateReducer } from "./pdfTemplatesReducer"
import { cameraMicAccessReducer } from "./cameraMicAccessReducer"
import { coachConsultationReducer } from "./coachConsultationReducer"
import { interventionReducer } from "./interventionReducer"
import { goalsReducer } from "./goalsReducer"
import { dishNutritionInfoReducer } from "./dishNutritionInfoReducer"
import { dietPlanReducer } from "./dietPlanReducer"
import { chatReducer } from "./chatReducer"
import { twilioReducer } from "./twilioReducer"
import { rcaEditDataReducer } from "./rcaEditDataReducer"
import { rcaPatientListDataReducer } from "./rcaPatientListDataReducer"
import { taskManagerReducer } from "./taskManagerReducers"
import { voipCallReducter } from "./voipCallReducer"
import { appConfigReducer } from "./appConfigReducer"
import { audioChucksReducer } from "./audioChucksReducer"
import { bcaDataReducer } from "./bcaDataReducer"
import { mealPlanProtocolReducer } from "./mealPlanProtocolReducer"
import { userTimezoneReducer } from "./timezoneReducer"
import { psychologicalAssessmentReducer } from "./psychologicalAssessmentReducer"

export const combinedReducers = combineReducers<IAppState>({
	doctorProfile: doctorProfileReducer,
	accountData: accountDataReducer,
	doctorTenant: doctorTenantReducer,
	patientData: patientDataReducer,
	selectedDoctorType: doctorSelectionReducer,
	staticData: staticDataReducer,
	ongoingDoctorConsultation: ongoingDoctorConsultationReducer,
	suggestions: sectionSuggestionReducer,
	pdfTemplates: pdfTemplateReducer,
	cameraMicAccessAvailable: cameraMicAccessReducer,
	coachConsultation: coachConsultationReducer,
	interventions: interventionReducer,
	goals: goalsReducer,
	dishNutritionInfoMap: dishNutritionInfoReducer,
	dietPlan: dietPlanReducer,
	chat: chatReducer,
	twilioContext: twilioReducer,
	rcaEditData: rcaEditDataReducer,
	rcaPatientListData: rcaPatientListDataReducer,
	taskManager: taskManagerReducer,
	voipCall: voipCallReducter,
	appConfig: appConfigReducer,
	audioChunks: audioChucksReducer,
	bcaData: bcaDataReducer,
	mealPlanProtocol: mealPlanProtocolReducer,
	userTimezone: userTimezoneReducer,
	psychologicalAssessment: psychologicalAssessmentReducer,
})

const AllReducer = (state: any, action: any) => {
	if (action.type === "RESET_STORE") {
		state = {}
	}
	try {
		return combinedReducers(state, action)
	} catch (e) {
		console.error("Error at Combining reducer", e)
	}
}

// const composeEnhancers = ((window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__()) || compose

const middlewares: Middleware[] = [thunk]

export const store = configureStore({ reducer: AllReducer, middleware: middlewares })
